// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Au79","header":"ReportDetails_header__3BbG8","title":"ReportDetails_title__LwgIJ","left":"ReportDetails_left__2aNe1"};